export default {
  USD : 0,
  CAD : 1,
  EUR : 2,
  MXN : 3,
  AUD : 4
};